import React from "react";
import s from "./style.module.scss";
import GoBack from "shared/ui/GoBack";
import { NoAuthContentProps } from "./types";
import ImageLazy from "shared/ui/ImageLazy";

const NoAuthContent: React.FC<NoAuthContentProps> = ({ gift, news }) => {
  return (
    <section className={s.content}>
      <div className={s.top}>
        <GoBack className={s.go_back} />

        <div className={s.image}>
          {gift?.image && <ImageLazy src={gift.image} alt="Gift" />}
        </div>
      </div>

      <div className={s.block}>
        {gift && gift?.malls.length > 0 && (
          <ul className={s.malls}>
            {gift.malls.map((item) => (
              <li key={item.id} className={s.item}>
                {item.title}
              </li>
            ))}
          </ul>
        )}

        <h1>{gift?.title}</h1>

        <div className={s.row}>
          <span className={s.shop}>{gift?.place_title}</span>

          {gift?.period_to && (
            <span className={s.date}>
              {new Date(gift.period_to).toLocaleDateString()}
            </span>
          )}
        </div>

        {gift && <div dangerouslySetInnerHTML={{ __html: gift?.text }}></div>}
      </div>
    </section>
  );
};

export default NoAuthContent;
